class DeliveryCountdown extends HTMLElement {
  connectedCallback() {
    const target = new Date(this.dataset.target).getTime();
    if (Number.isNaN(target)) return;

    this.target = target;
    this._tick = this.tick.bind(this);
    this.tick();
    this.interval = setInterval(this._tick, 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const remaining = this.target - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.textContent = '00:00:00';
      return;
    }

    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    this.textContent = [hours, minutes, seconds]
      .map((n) => String(n).padStart(2, '0'))
      .join(':');
  }
}

if (!customElements.get('delivery-countdown')) {
  customElements.define('delivery-countdown', DeliveryCountdown);
}
